import React from "react";
import {COMMON_PREFERENCE_TYPES} from "crqlar-react-common/dist/models/profile/preference.model";
import {labelizeUnderScoreText, useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {DietElement} from "crqlar-react-common/dist/components/uiElements/DietElement";
import {ElementChipList} from "./base/ElementChipList";

interface Props {
    diets: string[] | undefined;
    onClick?: (value: string) => void;
    onDelete?: (value: string) => void;
}

export function DietsElement({diets, onClick, onDelete}: Props) {
    const {tFallback} = useLocalize();
    const uniqueDiets = Array.from(new Set((diets ?? []).filter(Boolean)));

    if (!uniqueDiets.length) return null;

    return (
        <ElementChipList>
            {uniqueDiets.map(value => (
                <DietElement
                    key={value}
                    label={tFallback(
                        `${COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE}_${value}`,
                        labelizeUnderScoreText(value),
                    )}
                    value={value}
                    onClick={onClick ? () => onClick(value) : undefined}
                    onDelete={onDelete ? () => onDelete(value) : undefined}
                />
            ))}
        </ElementChipList>
    );
}
